import {
    Component,
    ChangeDetectionStrategy,
    ViewChild,
    ChangeDetectorRef,
    OnDestroy,
    OnInit
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';
import { FormHelperService } from '@classifieds-sell/shared';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { Subject } from 'rxjs';
import { MotorsSectionBase } from '../motors-section-base';

@Component({
    selector: 'motors-listing-details-header-section',
    templateUrl: './motors-listing-details-header-section.component.html',
    styleUrls: ['./motors-listing-details-header-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MotorsListingDetailsHeaderSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();
    selectedSellingType: number = null;
    sellingTypeInvalid = false;
    SellingTypeEnum = SellingTypeEnum;

    @ViewChild('motorsListingDetailsHeaderSectionForm')
    motorsListingDetailsHeaderSectionForm: NgForm;

    constructor(
        public draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _formHelperService: FormHelperService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this.sellingTypeInvalid = this.draftData.listingDetails.sellingType === SellingTypeEnum.undefined;
        this._formHelperService.validate(
            this.motorsListingDetailsHeaderSectionForm
        );

        this._changeDetectorRef.markForCheck();

        return this.motorsListingDetailsHeaderSectionForm.form.valid && !this.sellingTypeInvalid;
    }

    dirty(): boolean {
        return this.motorsListingDetailsHeaderSectionForm.form.dirty;
    }

    setSellingType(value: number) {
        this.sellingTypeInvalid = false;
        this.selectedSellingType = this.draftData.listingDetails.sellingType =
            value;
        this.motorsListingDetailsHeaderSectionForm?.form.markAsDirty();
        this.publish();
        this._changeDetectorRef.markForCheck();
    }

    // TODO: get rid of this comment after implemented
    // ### How to implement opening/closing modal ###
    // assuming modal is implemented using tg-modal
    // and the modal is wrapped in a shared component
    // render the shared component in template file
    // and refer to the below files for implementation
    // libs\property-ui\src\lib\sections\property-default-sections\property-promote-section\property-promote-section.component.ts
    // libs\property-ui\src\lib\sections\property-default-sections\property-promote-section\property-promote-section.component.html
}
